import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Overlay from '../Overlay/Overlay';
import { motion } from 'framer-motion';
import cx from 'classnames';
import './modal.scss';

class Modal extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    onDismiss: PropTypes.func,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
    name: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
  };

  static defaultProps = {
    size: 'medium',
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind();
  }

  handleClick = () => {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };

  render() {
    return (
      <Overlay onDismiss={this.handleClick}>
        <motion.div
          initial={{ opacity: 0, y: '-35%', x: '-50%' }}
          animate={{ opacity: 1, y: '-50%', x: '-50%' }}
          exit={{ opacity: 0, y: '-35%', x: '-50%' }}
          transition={{
            ease: [0.18, 0.89, 0.39, 1.4],
            duration: 0.3,
            delay: 0.1,
          }}
          className={cx('modal absolute bg-white shadow-lg rounded', {
            [this.props.name]: Boolean(this.props.name),
            'max-w-sm': this.props.size === 'small',
            'max-w-md': this.props.size === 'medium',
            'max-w-lg': this.props.size === 'large',
          })}>
          <div className="modal__header flex items-center justify-between p-4">
            {this.props.title}
            <button
              onClick={this.handleClick}
              className="cursor-pointer bg-transparent border-0 p-0">
              <svg>
                <path d="M19.6 5.5l-1-1.1-6.6 6.5-6.5-6.5-1.1 1 6.5 6.6-6.5 6.5 1 1.1 6.6-6.5 6.5 6.5 1.1-1-6.5-6.6 6.5-6.5z" />
              </svg>
            </button>
          </div>
          <div className="modal__content p-4">{this.props.children}</div>
          {this.props.footer && (
            <div className="modal__footer">{this.props.footer}</div>
          )}
        </motion.div>
      </Overlay>
    );
  }
}

export default  Modal;
